import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmationOverlay = _resolveComponent("ConfirmationOverlay")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ConfirmationOverlay, {
      acceptTheme: "primary",
      rejectTheme: "return",
      titleText: `Our records show the DOT inspection is due for this trailer. If you take this trailer will you call ${_ctx.assistanceCompany} to coordinate a new inspection?`,
      acceptText: "Accept",
      rejectText: "Decline",
      onAccept: _ctx.accept,
      onReject: _ctx.reject,
      disabled: _ctx.submitting
    }, null, 8, ["titleText", "onAccept", "onReject", "disabled"])
  ]))
}